// extracted by mini-css-extract-plugin
module.exports = {"PlaceImageSquare":"PlaceImageSquare_PlaceImageSquare__2zwXD","iconContainerClassName":"PlaceImageSquare_iconContainerClassName__1QhVL"};